import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import type { StatusDialog } from '../components/status-dialog/status-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class StatusDialogService {
  private readonly dialog = inject(MatDialog);

  async openStatusDialog(): Promise<MatDialogRef<StatusDialog, string>> {
    const module =
      await import('../components/status-dialog/status-dialog.component');

    return this.dialog.open<StatusDialog, null, string>(module.StatusDialog, {
      panelClass: ['status-dialog'],
    });
  }
}
